declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { ActorImageController, ActorDocController, ActorDocRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
//import { NgxMaskModule } from 'ngx-mask';
import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
//import './profilesteps.js';
//declare var mess1: any;
//declare var stepObject: any;
//declare var pSteps: any;
//declare var webGlObject: any;

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbDocumentModal } from './documents/documents.modal';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { NgbActorDocs2Modal } from '../modals/actordocs/actordocs2.modal';


@Component({
  selector: 'otherdatainfo',
  templateUrl: './otherdata.component.html',
  styleUrls: ['./otherdata.component.scss']
})

export class OtherDataComponent implements OnInit {

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() ActorDocPageCode: number;
  @Input() DocFriendlyName: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  public isRequesting: boolean = false;



  public ApiResData: ApiResponseModel;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();
  public isNew: boolean = false;
  public IsShowList: boolean = true;
  public showbutton: boolean = true;
  DOB: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  //
  public key: ActorPersonalDetailInfoController;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  //set Key(value: ActorPersonalDetailInfoController) {
  //  this.key = value;
  //  //  alertFunctions.AlertParam(this.Key);
  //  console.log('personalInfoChange');
  //  this.personalInfoChange.emit(this.key);
  //}
  //


  CurrentActorDocController: ActorDocController[];
  CurrentActorDocRequest: ActorDocRequest;
  CurrentActorDeleteDocRquest: ActorDocRequest;
  LoadDocuments() {

    this.CurrentActorDocRequest = new ActorDocRequest();

    //this.CurrentActorDocRequest.ActorDocPageCode = "";
    //this.CurrentActorDocRequest.ActorCode = this.ActorCode;
    //this.CurrentActorDocRequest.ActorDocCode = "";
    //this.CurrentActorDocRequest.EntryActorCode = "";
    //this.CurrentActorDocRequest.DocFriendlyName = "";
    //this.CurrentActorDocRequest.DocID = "";
    //this.CurrentActorDocRequest.DocTitle = "";
    //this.CurrentActorDocRequest.DocFileExtension = "";
    //this.CurrentActorDocRequest.DocRemarks = "";
    //this.CurrentActorDocRequest.EntryUserName = "";
    //this.CurrentActorDocRequest.SeqNo = "";
    //this.CurrentActorDocRequest.RecordStatus = "";
    //this.CurrentActorDocRequest.DocumentType = "";
    //this.CurrentActorDocRequest.DocType = "";
    //this.CurrentActorDocRequest.DocDate = "";
    this.CurrentActorDocRequest.ActorCode = this.ActorCode;
    this.CurrentActorDocRequest.ConditionalOperator = 20;
    this.CurrentActorDocRequest.ActorDocPageCode = 0;
    this.CurrentActorDocRequest.DocType = "Clincial Record"
    this.CurrentActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetActorDocController();
  }
  SelectedDocument: ActorDocController;
  GetActorDocController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);
    //alert(this.CurrentActorDocController.length);

    this.actorservice.GetActorDocController(this.CurrentActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }

  ngOnInit() {
   this.LoadDocuments();

    this.CurrentActorDeleteDocRquest = new ActorDocRequest;
    this.CurrentActorDeleteDocRquest.SendApiRequestModel = AppData.Instance().ApiRequestParms;



  }



  //ngAfterViewInit() {
  //  //pSteps.loadStep();
  //}

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //opendocuments(l: ActorDocController) {
  //  this.CurrentActorDocRequest.DocFileExtension = l.DocFileExtension;
  //  this.CurrentActorDocRequest.DocFriendlyName = l.DocFriendlyName;
  //  this.CurrentActorDocRequest.DocTitle = l.DocTitle;

  //  const modalRef = this.modalService.open(NgbDocumentModal,
  //    {
  //      centered: true

  //    })

  //  modalRef.componentInstance.Doc = l.ActorDocCode
  //  modalRef.componentInstance.DocFileExtension = l.DocFileExtension;
  //  modalRef.componentInstance.DocFriendlyName = l.DocFriendlyName;
  //  modalRef.componentInstance.DocTitle = l.DocTitle;
  //  modalRef.componentInstance.CurrentActorEditEmergencyInfoRequest = this.CurrentActorEditEmergencyInfoRequest;
  //  modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  //}
  //opendocuments(l: ActorDocController) {

  //    let options: NgbModalOptions = {
  //      centered: true
  //    };
  //  const modalRef = this.modalService.open(NgbDocumentModal, options)
  //  modalRef.componentInstance.ActorCode = l.ActorCode;
  //  modalRef.componentInstance.DocID = l.DocID;



  //}
  //  opendocuments(){
  //    var CurrentActorDocControllerByCode = this.CurrentActorDocController;

  //    const modalRef = this.modalService.open(NgbDocumentModal,
  //        {
  //          centered: true
  //        });

  //    modalRef.componentInstance.CurrentActorDocControllerByCode = CurrentActorDocControllerByCode[0];
  //}
  ClickedDocument: ActorDocController;
  //opendocuments(l: ActorDocController) {
  //  //this.CurrentActorDocRequest.ActorDocCode = l.ActorDocCode;
  //  //alert(this.CurrentActorDocRequest.ActorDocCode);
  //    let options: NgbModalOptions = {

  //      centered: true
  //    };
  //  const modalRef = this.modalService.open(NgbDocumentModal, options)
  //  modalRef.componentInstance.ActorDocPageCode = l.ActorDocPageCode;
  //  modalRef.componentInstance.DocFriendlyName = l.DocFriendlyName;
  //  modalRef.componentInstance.ActorCode = l.ActorCode;
  //    //modalRef.result.then(x => { this.GetActorIdentitiesController() })


  //}
    RefreshAll() {
        this.LoadDocuments();
    }
    AddNew() {
        let options: NgbModalOptions = {
            size: 'lg'
        };
        const modalRef = this.modalService.open(NgbActorDocs2Modal, options)//.result(result => { this.GetActorProfileController();});
        modalRef.componentInstance.ActorDocCode = 0;
        //alert(this.sectionData.ImageCode);
        modalRef.componentInstance.ActorCode = this.ActorCode;
        modalRef.result.then(x => { this.GetActorDocController() })
      
    }
  opendocuments(objCategory: any) {
    var document: ActorDocController = objCategory;
    if (document != null) {

      //this.router.navigate(['testnurse/serviceconfig']);
      this.ClickedDocument = document;
      //alert(document[0].ActorDocPageCode);
      let options: NgbModalOptions = {
        size: 'xl',
        centered: true
      };
      const modalRef = this.modalService.open(NgbDocumentModal, options)
      modalRef.componentInstance.DocFriendlyName = document.DocFriendlyName;
      modalRef.componentInstance.DocTitle = document.DocTitle;
      modalRef.componentInstance.DocCaptureDate = document.DocCaptureDate;
      modalRef.componentInstance.ActorDocPageCode = document.ActorDocPageCode;

    }
    else {

    }
  }


  del_(ActorDocPageCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(ActorDocPageCode);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(ActorDocPageCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorDeleteDocRquest.ConditionalOperator = 3;
    this.CurrentActorDeleteDocRquest.ActorDocPageCode = ActorDocPageCode;
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
    this.actorservice.SaveActorDocs(this.CurrentActorDeleteDocRquest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            //this.ShowList = true;
            this.LoadDocuments();

            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

}
